import React from 'react';
import * as S from './BreadCrumbs.styles';
import Icon from '../../../../core-components/IconsSelector';
import InboundCallWidget from '../../../../../shared/pages/SeoPage/containers/InboundCallWidget/InboundCallWidget';

export interface ICrumbs {
    title: string,
    url: string
}
export interface IBreadCrumbs {
    breadCrumbs: Array<ICrumbs>
    showInboundCall:boolean;
    contactNumber: string;
}

export default function(props: IBreadCrumbs) {
    const { breadCrumbs, showInboundCall, contactNumber } = props;
    if (breadCrumbs && breadCrumbs.length > 0) {
        return (
            <S.BreadCrumbsWrapper>
                <S.BreadCrumbsWrapper itemScope itemType="https://schema.org/BreadcrumbList">
                    {breadCrumbs.map((item, index) => {
                        if (index === breadCrumbs.length - 1) {
                            return null;
                        }
                        return (
                            <div
                                key={item?.title}
                                itemProp="itemListElement"
                                itemScope
                                itemType="https://schema.org/ListItem"
                            >
                                <S.Crumbs itemProp="item" href={item?.url}>
                                    <span itemProp="name">{item?.title}</span>
                                    <meta itemProp="position" content={`${index + 1}`} />
                                    <S.Icon>
                                        <Icon
                                            name="ArrowRightIcon"
                                            styleProps={{
                                                width: "10px",
                                                height: "10px",
                                                margin: "0 0 0 0",
                                                fill: "#2276e3"
                                            }}
                                        />
                                    </S.Icon>
                                </S.Crumbs>
                            </div>
                        )
                    })}
                    <S.ActiveCrumbs itemProp="itemListElement" itemScope itemType="https://schema.org/ListItem">
                        <span itemProp="name">{breadCrumbs[breadCrumbs?.length - 1]?.title}</span>
                        <meta itemProp="position" content={`${breadCrumbs?.length}`} />
                    </S.ActiveCrumbs>
                </S.BreadCrumbsWrapper>
                {showInboundCall ? 
                <InboundCallWidget 
                    inboundCallText="Talk to agent (24x7)"
                    inboundCallNumber={contactNumber}
                    isForm={false}
                /> : null}
            </S.BreadCrumbsWrapper>
        )
    }
    return null;
}